import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@/components/Grid/components/Table/formatters';
import { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('email', 'E-mail', undefined, { enableTruncate: true }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
